export default function MinorHeadingTitle({ children }) {

    return (
        <h4 className="text-[#f7f8f8] text-base font-semibold pb-4">
            {children}
        </h4>
    )
}
